// @flow
/* eslint-disable react/no-array-index-key */
import React, { Fragment } from 'react';
import range from 'lodash/range';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import * as icons from 'react-icons/lib/md';

import * as actions from '../../actions/temporaryEvents';
import * as fromTemporaryEvents from '../../reducers/temporaryEvents';

import styles from './flashMessage.css';


type FlashMessagePropTypes = {
  status: number,
  message: string,
  accented?: Array<number> | number,
  iconName?: string,
  onClose?: Function,
  onClick?: Function,
  isActive?: boolean,
  imageURL?: string,
  lifespan?: number,
};

type FlashMessageStateTypes = {
  hasLoaded: boolean,
  ticks: Number,
};

export const FLASH_MESSAGE_STATUS = {
  default: 0,
  success: 1,
  error: -1,
};

class FlashMessage extends React.Component<FlashMessagePropTypes, FlashMessageStateTypes> {
  constructor(props: FlashMessagePropTypes) {
    super(props);

    this.state = {
      hasLoaded: false,
    };
  }

  componentDidMount() {
    const { onClose, lifespan } = this.props;

    if (onClose && lifespan) {
      setTimeout(() => onClose(), lifespan);
    }

    this.setState({
      hasLoaded: true,
    });
  }

  render() {
    const {
      status = FLASH_MESSAGE_STATUS.default,
      message,
      accented,
      iconName,
      isActive = true,
      onClose,
      onClick,
      imageURL,
    } = this.props;

    const Icon = iconName ? icons[iconName] : undefined;
    const { hasLoaded } = this.state;

    const splitted = message.split(' ');
    let accentedIndexes = [];
    if (typeof accented === 'number') {
      accentedIndexes = range(accented);
    } else if (accented != null) {
      accentedIndexes = accented;
    }

    const builtMessage = splitted.map((word, index) => (
      accentedIndexes.includes(index) ? (
        <strong className={styles.word} key={index}>
          { word }
        </strong>
      ) : (
        <span className={styles.word} key={index}>
          { word }
        </span>
      )
    ));

    return (
      <Fragment>
        <CSSTransition
          in={hasLoaded && isActive}
          timeout={250}
          classNames={styles}
          unmountOnExit
        >
          <div
            className={
              `
                ${styles.flashMessage}
                ${styles[status] ? styles[status] : ''}
              `
            }
            role="presentation"
            onClick={onClick}
          >
            <button type="button" className={styles.close} onClick={onClose}>
              &times;
            </button>
            {
              Icon && (
                <div className={styles.icon}>
                  <Icon size={30} />
                </div>
              )
            }
            {
              imageURL && (
                <div className={styles.image}>
                  <img src={imageURL} alt="Indicator" />
                </div>
              )
            }
            <div className={styles.message}>
              { builtMessage }
            </div>
          </div>
        </CSSTransition>
      </Fragment>
    );
  }
}


export default connect(
  (state, temporaryEvent) => ({
    isActive: fromTemporaryEvents.isActive(temporaryEvent),
  }),
  (dispatch, { id }) => ({
    onClose() {
      dispatch(actions.cancel(id));
    },
  }),
)(FlashMessage);



// WEBPACK FOOTER //
// ./src/scripts/components/FlashMessages/FlashMessage.jsx